import React, { useState } from "react";
import useInViewOnce from "../useInViewOnce";
import { mockGallery } from "../../../mock";
import GalleryAlbum from "../../../components/gallery/GalleryAlbum";

const categories = ["Semua", "Workshop", "Bazar", "Event"];

const GallerySection = () => {
  const [activeTab, setActiveTab] = useState("Semua");
  const [setRef, isInView] = useInViewOnce();

  const filteredGallery =
    activeTab === "Semua"
      ? mockGallery
      : mockGallery.filter((item) => item.category === activeTab);

  return (
    <section id="galeri" className="px-4 mb-12 md:mb-20 sm:px-6 md:px-0">
      <div
        ref={setRef}
        className={`${
          isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        } transition-all duration-500 ease-out`}
      >
        {/* HEADER */}
        <header className="max-w-xl mb-6 md:mb-8">
          <h2 className="text-base font-semibold tracking-tight text-foreground sm:text-lg md:text-xl">
            Aktivitas Cineurasa
          </h2>
          <p className="mt-1 text-xs text-muted-foreground sm:text-sm">
            Dokumentasi kegiatan workshop, bazar, dan event Cineurasa.
          </p>
        </header>

        {/* TABS */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveTab(cat)}
              className={`rounded-full px-4 py-1.5 text-[11px] font-medium transition
                ${
                  activeTab === cat
                    ? "bg-primary text-primary-foreground shadow"
                    : "bg-secondary text-muted-foreground hover:bg-secondary/80"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* CONTENT */}
        <div className="space-y-12">
          {filteredGallery.length > 0 ? (
            filteredGallery.map((album) => (
              <GalleryAlbum key={album.id} album={album} />
            ))
          ) : (
            <p className="text-sm text-muted-foreground">
              Belum ada dokumentasi untuk kategori ini.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
